// @flow
import axios from "../axios";

export const saveLearnerForm = async (learner) => {
	return await axios.post("/api/learner", learner);
};

export const submitLearnerAnswer = async (answer) => {
	return await axios.post("/api/learner/submit-answer", answer);
};

export const submitCourseReady = async (data) => {
	return await axios.post("/api/learner/submit-course-ready", data);
};



// WEBPACK FOOTER //
// ./src/utils/api/learner.js